import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const braze = defineConnector({
  identifier: "braze",
  name: "Braze",
  tagLine: "Customer engagement platform",
  keywords:
    "appboy crm marketing automation push notifications campaigns canvas messaging",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://rest\\..+\\.braze\\.(com|eu)/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Select your Braze instance",
      items: [
        {
          kind: "select",
          label: "Braze instance",
          required: true,
          target: { kind: "configuration", field: "instance" },
          options: [
            { value: "rest.iad-01.braze.com", label: "US-01" },
            { value: "rest.iad-02.braze.com", label: "US-02" },
            { value: "rest.iad-03.braze.com", label: "US-03" },
            { value: "rest.iad-04.braze.com", label: "US-04" },
            { value: "rest.iad-05.braze.com", label: "US-05" },
            { value: "rest.iad-06.braze.com", label: "US-06" },
            { value: "rest.iad-07.braze.com", label: "US-07" },
            { value: "rest.iad-08.braze.com", label: "US-08" },
            { value: "rest.fra-01.braze.eu", label: "EU-01" },
            { value: "rest.fra-02.braze.eu", label: "EU-02" },
          ],
          defaultValue: "rest.iad-01.braze.com",
          helperText: "Select the Braze instance your account uses.",
        },
      ],
    },
    {
      title: "Get your Braze API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Braze, go to **Settings > APIs and Identifiers > API Keys** and create a new REST API key with the required permissions.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "REST API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instance }) => `https://${instance}/campaigns/list`,
  },
  publicEnvVars: ({ instance }) => ({
    BRAZE_URL: instance ? `https://${instance}` : "",
  }),
});
